import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RegularInspectionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.476 7.47837V12.2163L16.5216 14.6178L15.851 15.7644L11.113 12.887V7.47837H12.476ZM12 19.226C13.2981 19.226 14.5096 18.8942 15.6346 18.2308C16.7308 17.5962 17.5962 16.7308 18.2308 15.6346C18.8942 14.5096 19.226 13.2981 19.226 12C19.226 10.7019 18.8942 9.49039 18.2308 8.36538C17.5962 7.26923 16.7308 6.40385 15.6346 5.76923C14.5096 5.10577 13.2981 4.77404 12 4.77404C10.7019 4.77404 9.49039 5.10577 8.36538 5.76923C7.26923 6.40385 6.40385 7.26923 5.76923 8.36538C5.10577 9.49039 4.77404 10.7019 4.77404 12C4.77404 13.2981 5.10577 14.5096 5.76923 15.6346C6.40385 16.7308 7.26923 17.5962 8.36538 18.2308C9.49039 18.8942 10.7019 19.226 12 19.226ZM12 3C13.6442 3 15.1659 3.41105 16.5649 4.23317C17.9207 5.01202 18.988 6.07932 19.7668 7.4351C20.5889 8.83414 21 10.3558 21 12C21 13.6442 20.5889 15.1659 19.7668 16.5649C18.988 17.9207 17.9207 18.988 16.5649 19.7668C15.1659 20.5889 13.6442 21 12 21C10.3558 21 8.83414 20.5889 7.4351 19.7668C6.07932 18.9736 5.01202 17.899 4.23317 16.5433C3.41105 15.1442 3 13.6298 3 12C3 10.3702 3.41105 8.85578 4.23317 7.45673C5.02645 6.10095 6.10096 5.02645 7.45673 4.23317C8.85578 3.41105 10.3702 3 12 3Z'
        />
    ),
})

RegularInspectionIcon.displayName = 'RegularInspectionIcon'
